import { trainerCarousel } from "@/scripts/sections/trainer-carousel";

document.addEventListener('DOMContentLoaded', () => {
    trainerCarousel().initTrainerCarousel();
})